import { LongerArrowRightIcon } from '@/components/Icons/LongerArrowRightIcon.js';
import { Layout } from '@/components/Layout/Layout.js';
import { FONT_FAMILY_VARIANTS } from '@/components/Typography/constants.js';
import { Heading } from '@/components/Typography/Heading.js';
import { Smallcaps } from '@/components/Typography/Smallcaps.js';
import { styled } from '@/stitches/index.js';
import { isTheme } from '@/stitches/isTheme.js';
import { dawn } from '@/templates/sydney/themes/dawn.js';
import { midnight } from '@/templates/sydney/themes/midnight.js';
import { pxToRem } from '@/utilities/pxToRem.js';

const Title = styled(Heading, {
  '@bp0': {
    fontSize: '$28',
  },
  '@bp3': {
    fontSize: '$64',
  },
  fontWeight: '$medium',
  letterSpacing: '-$safe1px',
  lineHeight: 1.4,
  variants: {
    fontFamily: {
      ...FONT_FAMILY_VARIANTS,
      generalSans: {
        fontWeight: '$semiBold',
      },
      panchang: {
        '@bp0': {
          fontSize: '$20',
        },
        '@bp2': {
          fontSize: '$32',
        },
        '@bp4': {
          fontSize: '$40',
        },
      },
      switzer: {
        fontWeight: '$medium',
      },
      syne: {
        fontWeight: '$medium',
      },
      zodiak: {
        fontWeight: '$regular',
      },
    },
  },
});

const Roles = styled(Smallcaps, {
  '@bp0': {
    fontSize: '$14',
    lineHeight: 1.2,
  },
  '@bp3': {
    fontSize: '$20',
    lineHeight: 1.4,
    marginTop: '$16',

    [`${isTheme([dawn, midnight])}`]: {
      marginTop: 0,
    },
  },
  fontWeight: 500,
  letterSpacing: pxToRem(1),
  variants: {
    isProjectPage: {
      true: {
        '@bp3': {
          fontSize: '$16',
          lineHeight: 1,
        },
      },
    },
  },
});

const StyledArrowRightIcon = styled(LongerArrowRightIcon, {
  '@bp0': {
    height: pxToRem(26),
    width: pxToRem(49),
  },
  '@bp3': {
    height: pxToRem(48),
    width: pxToRem(92),
  },
  marginLeft: '$16',
  paddingRight: pxToRem(2),
  transition: 'margin $basicDuration ease',
});

const ProjectAnchor = styled('a', {
  '&:hover': {
    [`${StyledArrowRightIcon}`]: {
      marginLeft: '$32',
    },
    opacity: 0.7,
  },
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
  transition: 'opacity $basicDuration ease',
});

const StyledFlexRow = styled(Layout.FlexRow, {
  alignItems: 'center',
  [`${Title}`]: {
    '@bp0': {
      maxWidth: '$280',
    },
    '@bp1': {
      maxWidth: 'unset',
    },
  },
});

export { ProjectAnchor, Roles, StyledArrowRightIcon, StyledFlexRow, Title };
